module.exports = "\r\n\r\n.row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.label-color{\r\n    color:blue;\r\n}\r\n\r\n.display-content{\r\n    margin: 10px 15px;\r\n    border: 1px solid gray;\r\n    padding: 15px;\r\n}\r\n\r\n.border-view{\r\n    margin: 5px;\r\n    padding: 5px 15px;\r\n    border: 1px solid gray;\r\n}\r\n\r\nspan{\r\n    font-weight: 700;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/depart-enquiry/show-case-noties/show-case-form/show-case-form.component.css
// module id = ./src/app/hrms/depart-enquiry/show-case-noties/show-case-form/show-case-form.component.css
// module chunks = main